// extracted by mini-css-extract-plugin
export default {"wrap":"UserStrip_wrap__q3HGw","user-image-wrap":"UserStrip_user-image-wrap__JOb32"};